let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8m50R")).then(() => parcelRequire('6rKLI'));